import script from "./OperationsOverviewBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsOverviewBoard.vue?vue&type=script&setup=true&lang=js"

import "./OperationsOverviewBoard.vue?vue&type=style&index=0&id=6585d242&lang=scss"

const __exports__ = script;

export default __exports__